import React, { useRef } from "react";
import { FiSettings, FiX } from "react-icons/fi";
import styles from "./style.module.scss";

export default function RaceBuilderConfig() {
  const dialogRef = useRef<HTMLDialogElement>(null);

  return (
    <>
      <button
        className={styles.configButton}
        type="button"
        aria-label="Open Race Builder configuration"
        aria-haspopup="dialog"
        aria-controls="race-builder-config"
        title="Race Builder configuration"
        onClick={() => dialogRef.current?.showModal()}
      >
        <FiSettings aria-hidden="true" />
      </button>
      <dialog
        ref={dialogRef}
        id="race-builder-config"
        className={styles.configDialog}
        aria-labelledby="race-builder-config-title"
        aria-describedby="race-builder-config-description"
        onClick={(event) => {
          if (event.target === event.currentTarget) {
            dialogRef.current?.close();
          }
        }}
      >
        <div className={styles.configContent}>
          <div className={styles.configHeader}>
            <h2 id="race-builder-config-title">Race Builder configuration</h2>
            <button
              className={styles.configButton}
              type="button"
              aria-label="Close Race Builder configuration"
              autoFocus
              onClick={() => dialogRef.current?.close()}
            >
              <FiX aria-hidden="true" />
            </button>
          </div>
          <p id="race-builder-config-description" className={styles.configHint}>
            No configuration options yet.
          </p>
        </div>
      </dialog>
    </>
  );
}
